// Same list as user-dashboard src/constans/timezones.constants.ts (pop-up store life span)
export const DEFAULT_TIMEZONE = 'America/New_York'

export const TIMEZONES = [
  { text: 'Pacific Time (PT) — UTC-8 / UTC-7', value: 'America/Los_Angeles' },
  { text: 'Mountain Time (MT) — UTC-7 / UTC-6', value: 'America/Denver' },
  { text: 'Central Time (CT) — UTC-6 / UTC-5', value: 'America/Chicago' },
  { text: 'Eastern Time (ET) — UTC-5 / UTC-4', value: 'America/New_York' },
  { text: 'Greenwich Mean Time (GMT/BST) — UTC / UTC+1', value: 'Europe/London' },
  { text: 'Central European Time (CET/CEST) — UTC+1 / UTC+2', value: 'Europe/Berlin' },
  { text: 'Israel Time (IST) — UTC+2 / UTC+3', value: 'Asia/Jerusalem' },
  { text: 'Gulf Standard Time (GST) — UTC+4', value: 'Asia/Dubai' },
  { text: 'India Standard Time (IST) — UTC+5:30', value: 'Asia/Kolkata' },
  { text: 'China Standard Time (CST) — UTC+8', value: 'Asia/Shanghai' },
  { text: 'Japan Standard Time (JST) — UTC+9', value: 'Asia/Tokyo' },
  { text: 'Australian Eastern Time (AEST/AEDT) — UTC+10 / UTC+11', value: 'Australia/Sydney' },
  { text: 'Brasília Time (BRT) — UTC-3', value: 'America/Sao_Paulo' },
]
